import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { remove_analytics_loading : true, remove_analytics: '', remove_analytics_error: false};

export function removeAnalyticsOrgAdmin(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_REMOVE_ANALYTICS_ORG_ADMIN:
        return {
            remove_analytics_loading: true,
            remove_analytics: '',
            remove_analytics_error: false
        };
      case organisationConstants.RESPONSE_REMOVE_ANALYTICS_ORG_ADMIN:
        return {
            remove_analytics_loading: false,
            remove_analytics: action.add_analytics_org_admin,
            remove_analytics_error: false
        };
      case organisationConstants.ERROR_REMOVE_ANALYTICS_ORG_ADMIN:
        return {
            remove_analytics_loading: false,
            remove_analytics: '',
            remove_analytics_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/removeAnalyticsOrgAdmin.reducer.js